/**
 * https://internal.msmaster.qa.paypal.com/elmo/experiment/149334
 *
 * Conditions:
 * - Ctrl_p2p_remove_preselection_logic: We will continue using customized logic in p2pnodeweb for selecting a funding option for a payment and showing the FI page/dialog.
 * - Trmt_p2p_remove_preselection_logic: We will rely more in services to select a funding option for a payment and showing FI page/dialog.
 */

import * as pxp from '../lib/pxp'

export function removePreselectionLogic() {
  return pxp.isTreatment('Trmt_p2p_remove_preselection_logic')
}
